



















































































































import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    PropType,
    Ref,
    ref,
    onMounted,
    watch,
} from '@vue/composition-api';
import Vue from 'vue';
import {
    getTime,
    startOfMonth,
    endOfMonth,
    endOfQuarter,
    startOfQuarter,
    startOfYear,
    endOfYear,
    subDays,
    intervalToDuration,
} from 'date-fns';
import chartLine from './chart-line.vue';
import chartBar from './chart-bar.vue';
import chartMix from './chart-mix.vue';
import multiSelect from './multi-select.vue';
import singleSelect from './single-select.vue';
import tableModule from './game/table-module.vue';
import { ChartGroupType, LinkageParamType, GroupSearchOption } from '../type';
interface PlatOptionItem {
    caption: string;
    title: string;
}
const DateOptions = [
    {
        title: '本月',
        caption: 'month',
    },
    {
        title: '本季度',
        caption: 'quarter',
    },
    {
        title: '本年',
        caption: 'year',
    },
];

export default defineComponent({
    components: {
        chartLine,
        chartBar,
        chartMix,
        multiSelect,
        singleSelect,
        tableModule,
    },
    props: {
        data: {
            type: Object as PropType<ChartGroupType>,
            default: () => {
                return {
                    groupSearchOption: [],
                };
            },
        },
        isGameTab: {
            type: Boolean,
            default: false,
        },
        appId: {
            type: String,
            required: true,
        },
    },
    setup(props, context) {
        const dateInterval = ref('');
        const activeDateLabel = ref('month');
        const linkageParams: Ref<LinkageParamType> = ref({
            dateRange: [],
        });
        const timeLabel = ref('month');
        const dateOptions = DateOptions;
        const isShowCharts = ref(false);

        const isShowDatePick = computed(() => {
            return (
                props.data.groupSearchOption.findIndex(
                    (item: GroupSearchOption) => {
                        return item.searchName === 'dateRange';
                    },
                ) !== -1
            );
        });

        function refreshGroupDate(params: Array<number>) {
            timeLabel.value = '';
            const interval: Record<string, any> = intervalToDuration({
                start: params[0],
                end: params[1],
            });
            if (interval.years > 0) {
                context.root.$message({
                    type: 'error',
                    message: '时间区间不能超过一年，请重新选择',
                    customClass: 'message-custom message-error-custom',
                    iconClass: 'message-error-custom-icon',
                });
                dateInterval.value = '';
                return;
            }
            linkageParams.value.dateRange = params;
            timeLabel.value = 'custom';
            activeDateLabel.value = 'custom';
        }

        function selectDate(label: string) {
            if (activeDateLabel.value === label) {
                return;
            }
            dateInterval.value = '';
            linkageParams.value.dateRange = [];
            activeDateLabel.value = label;
            if (label === 'month') {
                linkageParams.value.dateRange.push(
                    getTime(startOfMonth(new Date())),
                );
                linkageParams.value.dateRange.push(
                    getTime(endOfMonth(new Date())),
                );
                timeLabel.value = 'month';
            } else if (label === 'quarter') {
                linkageParams.value.dateRange.push(
                    getTime(startOfQuarter(new Date())),
                );
                linkageParams.value.dateRange.push(
                    getTime(endOfQuarter(new Date())),
                );
                timeLabel.value = 'quarter';
            } else {
                linkageParams.value.dateRange.push(
                    getTime(startOfYear(new Date())),
                );
                linkageParams.value.dateRange.push(
                    getTime(endOfYear(new Date())),
                );
                timeLabel.value = 'year';
            }
        }

        const inputDateVal = computed({
            get: () => {
                return activeDateLabel.value === 'custom'
                    ? ''
                    : activeDateLabel.value;
            },
            set: (val) => {
                selectDate(val);
            },
        });

        function initCharts() {
            isShowCharts.value = false;
            dateInterval.value = '';
            linkageParams.value.dateRange = [];
            linkageParams.value.dateRange.push(
                getTime(startOfMonth(new Date())),
            );
            linkageParams.value.dateRange.push(getTime(endOfMonth(new Date())));
            props.data.groupSearchOption.forEach((searchItem) => {
                if (searchItem.searchName !== 'dateRange') {
                    const firstCaption = searchItem.searchOption
                        .split(';')[0]
                        .split('|')[0];
                    Vue.set(linkageParams.value, searchItem.searchName, [
                        firstCaption,
                    ]);
                }
            });
            activeDateLabel.value = 'month';
            timeLabel.value = 'month';
            isShowCharts.value = true;
        }

        watch(
            () => props.appId,
            (val) => {
                if (val) {
                    initCharts();
                }
            },
            { immediate: true },
        );

        function updateMultiChecked(params: Record<string, any>) {
            Vue.set(linkageParams.value, params.type, params.value);
        }

        function updateSingleChecked(params: Record<string, any>) {
            Vue.set(linkageParams.value, params.type, [params.value]);
        }
        onMounted(() => {
            if (props.data.groupSearchOption.length) {
                props.data.groupSearchOption.forEach((searchItem) => {
                    if (searchItem.searchName !== 'dateRange') {
                        const firstCaption = searchItem.searchOption
                            .split(';')[0]
                            .split('|')[0];
                        Vue.set(linkageParams.value, searchItem.searchName, [
                            firstCaption,
                        ]);
                    }
                });
            }
        });

        return {
            dateInterval,
            activeDateLabel,
            selectDate,
            refreshGroupDate,
            linkageParams,
            isShowCharts,
            dateOptions,
            timeLabel,
            isShowDatePick,
            inputDateVal,
            updateMultiChecked,
            updateSingleChecked,
        };
    },
});
